import { render, staticRenderFns } from "./SafePointPopup.vue?vue&type=template&id=2b2c9820&scoped=true&"
import script from "./SafePointPopup.vue?vue&type=script&lang=js&"
export * from "./SafePointPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c9820",
  null
  
)

export default component.exports